<form [formGroup]="residenciaForm">
  <div class="form-group">
    <span class="icon"></span>

    <div class="inputs field-group__pesados">
      <label for="condicoes-residencia">Condições da Residência</label>

      <select
        id="condicoes-residencia"
        class="form-control"
        name="condicoesResidencia"
        required
        appShowErrorMessages
        requiredMessage="Condições da Residência é obrigatório"
        formControlName="condicaoResidencia"
        (change)="onChangeCondicoesResidencia()">
        <option value="" selected hidden>Selecione...</option>
        <option *ngFor="let condicaoResidencia of listaCondicoesResidencia" [ngValue]="condicaoResidencia.id">{{ condicaoResidencia.descricao }}</option>
      </select>

      <input
        id="condicaoResidenciaOutro"
        *ngIf="showCondicaoResidenciaOutro"
        type="text"
        autocomplete="off"
        class="form-control field-group__outro"
        name="condicaoResidenciaOutro"
        formControlName="condicaoResidenciaOutro"
        placeholder="Digite outra condição da Residênca..."
        minlength="1"
        maxlength="30"
        (blur)="onBlurCondicaoResidenciaOutro()"
        uppercase
      />
      <div
        class="text-danger"
        *ngIf="showCondicaoResidenciaOutro && (condicaoResidenciaOutro.value === '' || condicaoResidenciaOutro.value === null) && condicaoResidenciaOutroTouched">
        Campo Obrigatório
      </div>
    </div>
  </div>

  <div class="form-group">
    <span class="icon"></span>
    <div class="inputs">
      <label for="residence-time">Tempo de Residência</label>
      <input
        type="text"
        class="form-control"
        id="residence-time"
        name="tempoResidencia"
        formControlName="tempoResidencia"
        placeholder="Digite apenas números (Mês/Ano)"
        mask-number
        [mask]="'00/0000'"
        appTwoDigitsValidator
        appShowErrorMessages
        requiredMessage="Tempo de Residência é obrigatório"
        required/>
    </div>
  </div>
</form>
